import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=0bd28b08&scoped=true&"
import script from "./videoDialog.vue?vue&type=script&lang=js&"
export * from "./videoDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=0bd28b08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd28b08",
  null
  
)

export default component.exports